import PropTypes from 'prop-types';

var propTypes = {
    isOpen: PropTypes.bool.isRequired,
    applicationName: PropTypes.string.isRequired,
    links: PropTypes.arrayOf(PropTypes.object).isRequired,
    onClose: PropTypes.func.isRequired,
    onSelectLink: PropTypes.func.isRequired,
};

export { propTypes };
